import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { SharedConstants } from '../shared.const';

import {TranslateService} from 'ng2-translate';
import { HttpClientService } from './http-client.service';
import { CookieManagerService } from './cookie-manager.service';
import { SpinnerService } from './spinner.service';
import { AlertManagerService } from './alert-manager.service';

@Injectable()
export class AuthService {

  private headers;

  constructor(
    private http: Http,
    private router: Router,
    private alertService: AlertManagerService,
    private cookieService: CookieManagerService,
    private httpClient: HttpClientService,
    private translateService: TranslateService,
    private spinnerService: SpinnerService,
  ) { }

  signIn(authKey: any): Observable<any>{
    this.beforeStart();
    let body = JSON.stringify({
      'key': authKey
    });
    return this.http.post(this.getFullUrl(SharedConstants.apiAuth), body, { headers: this.headers })
      .catch((error: any) => {
        this.onCatch(error);
        return Observable.throw(error);
      })
      .map((response: Response) => {
        let body = response.json();
        this.cookieService.setCookie(SharedConstants.basicConstans.cookieToken, body.data[SharedConstants.keyToken], false, 1);
        return body;
      })
      .finally(() => {
        this.onFinally();
      });
  }

  logIn(authKey){
    return this.httpClient.post(SharedConstants.apilogin,authKey);
  }

  loginWithGoogle(data){
    return this.httpClient.post(SharedConstants.apiGoogleLogin, data);
  }

  signOut(){
    this.httpClient.delete('auth/invalidate').subscribe(
      logout => {
        this.cookieService.removeAllCookie();
        window.location.href = SharedConstants.basicConstans.loginUrl;
        // this.router.navigate([SharedConstants.basicConstans.linkMyDashboard]);
      }
    );
  }

  /**
   * Build API url.
   * @param url
   * @returns {string}
   */
  private getFullUrl(url: string) {
    return SharedConstants.basicConstans.endPoint + '/' + url;
  }

  /**
   * Error handler.
   * @param error
   * @param caught
   * @returns {ErrorObservable}
   */
  private onCatch(error) {
    let err = error.json();
    if(err && err.message){
      this.alertService.error({title: "", msg: err.message});
    }else{
      this.alertService.error({title: "", msg: "There is no Internet connection"});
      // let interval = setInterval(() => {
      //   this.http.get(AuthConstants.Constants.endpoint).subscribe(
      //     sucess => {
      //       clearInterval(interval);
      //       this.responseInterceptor();
      //     }
      //   );
      // }, 3000);
    }
  }

  /**
     * Request interceptor.
     */
  private requestInterceptor(): void {
    this.spinnerService.start();
  }

  /**
   * Response interceptor.
   */
  private responseInterceptor(): void {
    this.spinnerService.stop();
  }

  /**
   * onFinally
   */
  private onFinally(): void {
    this.responseInterceptor();
  }

  private beforeStart() {
    this.requestInterceptor();
    this.headers = new Headers();
    this.createHeader();
  }

  private createHeader(): void {
    this.headers.append( SharedConstants.keyContentType, SharedConstants.valueContentType );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.service.ts